const toggleBtns = document.querySelectorAll('.js-crisis-toggle');
toggleBtns.forEach((el) => {
  el.addEventListener('click', () => {
    const body = window.document.querySelector('body');
    body.classList.add('overflow-hidden');

    const parentEl = el.parentElement.nextElementSibling;

    const headingEl = parentEl.querySelector('.crisis-message__heading');
    const headingText = headingEl.textContent;

    const messageEl = parentEl.querySelector('.crisis-message__message');
    const message = messageEl.cloneNode(true);

    const veil = document.createElement('div');
    veil.classList.add('crisis-message__veil');

    const windowWrapEl = document.createElement('div');
    windowWrapEl.classList.add('crisis-message__wrapping');
    veil.appendChild(windowWrapEl);

    const windowHeadingEl = document.createElement('h2');
    windowHeadingEl.classList.add('crisis-message__headline');
    const titleTextNode = document.createTextNode(headingText);
    windowHeadingEl.appendChild(titleTextNode);
    windowWrapEl.appendChild(windowHeadingEl);

    const messageOuterEl = window.document.createElement('div');
    messageOuterEl.classList.add('crisis-message__information-outer');
    windowWrapEl.appendChild(messageOuterEl);

    message.classList.remove('crisis-message__message');
    message.classList.add('crisis-message__information');
    messageOuterEl.appendChild(message);

    const windowCloseEl = document.createElement('button');
    windowCloseEl.classList.add('crisis-message__exit');
    windowCloseEl.addEventListener('click', () => {
      veil.remove();
      body.classList.remove('overflow-hidden');

      setTimeout(() => {
        el.focus();
      }, 10);
    });
    windowCloseEl.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') {
        event.preventDefault();

        const focusableElement = windowWrapEl.querySelector('a');
        if (focusableElement) {
          setTimeout(() => {
            focusableElement.focus();
          }, 10);
        } else {
          setTimeout(() => {
            windowCloseEl.focus();
          }, 10);
        }
      }
    });
    windowWrapEl.appendChild(windowCloseEl);

    const bodyEl = document.getElementsByTagName('body')[0];
    bodyEl.appendChild(veil);

    const focusableElement = windowWrapEl.querySelector('a');
    if (focusableElement) {
      focusableElement.focus();
    } else {
      windowCloseEl.focus();
    }
  });
});
